// src/config/env.ts

import { resolveBrandId, type BrandId } from './brand';

// 1. Declaración global para window._env_ (runtime config)
declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

// 2. Función inteligente: Busca en window (Runtime) y si no, en Vite (Build/Local)
const getEnv = (key: string, defaultValue: string = ''): string => {
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return import.meta.env[key] || defaultValue;
};

// 3. Exportamos la configuración limpia
export const config = {
  // API
  API_URL: getEnv('VITE_API_URL', 'http://localhost:3000'),
  API_PREFIX: getEnv('VITE_API_PREFIX', '/api/v1'),

  // Collaboration server (Hocuspocus WebSocket)
  COLLAB_URL: getEnv('VITE_COLLAB_URL', 'ws://localhost:1235'),

  // Autenticación
  RECAPTCHA_SITE_KEY: getEnv('VITE_RECAPTCHA_SITE_KEY'),
  GOOGLE_CLIENT_ID: getEnv('VITE_GOOGLE_CLIENT_ID'),
  MICROSOFT_CLIENT_ID: getEnv('VITE_MICROSOFT_CLIENT_ID'),
  MICROSOFT_TENANT_ID: getEnv('VITE_MICROSOFT_TENANT_ID', 'common'),

  // Entorno
  MODE: import.meta.env.MODE,
  IS_DEV: import.meta.env.DEV,
  APP_ENV: getEnv('VITE_APP_ENV', import.meta.env.MODE),

  // Branding (white-label). Se valida contra el registro de marcas; si la env
  // es inválida o vacía, cae en el fallback por defecto (AINOVIS).
  BRAND: resolveBrandId(getEnv('VITE_BRAND_NAME')) as BrandId,
};
